"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UnavailableForItemOverlay = void 0;
var _react = _interopRequireDefault(require("react"));
var _customisationModule = _interopRequireDefault(require("./customisation.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UnavailableForItemOverlay = exports.UnavailableForItemOverlay = function UnavailableForItemOverlay(props) {
  if (props.onItem || props.canAdd || props.id < 1) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "unavailable-overlay",
    className: _customisationModule["default"].unavailable
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].details
  }, "".concat(props.type.indexOf("Emb") < 0 ? "Print" : "Embroidery", " is not available")));
};
var _default = exports["default"] = UnavailableForItemOverlay;